import React from 'react';
import ReactDOM from 'react-dom';

import './rAF.js';

import { browserHistory, Router, Route, IndexRoute,IndexRedirect, Link } from 'react-router';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import VideoPlayBack from './VideoPlayBack';
import Chapter_One from './chapter_one';
import Chapter_Two from './chapter_two';
import Chapter_Three from './chapter_three';

//TEstCASE
import GeneratorElement from './chapter3/generatorElement';

import Intro from './intro';
import Outro from './outro-screen';

import FallbackPage from './fallbackPage';
import IOSFallback from './iOS_inline_fallback';
import Instagramfallback from './instagram_fallback';

import Evaluation_questions from './chapter2/evaluation_questions';

import '../styles/basestyle.scss';
import '../styles/chapter.scss';
import '../styles/transition-group.scss';

import Mobile_Chapter_one from './mobile_chapter_one';

const NoMatch = ({ location }) => (
  <div className="route-404">
    <h2>Whoops</h2>
    <p>Sorry but <span className="route-wrong">{location.pathname}</span> didn’t match any pages</p>
    <p>Go to <Link to={_assets.root + "/"} className="chapter-link-home" activeClassName="chapter-active">Chapter 1</Link></p>
  </div>
);


function App({ children, location }) {
  return (
      <ReactCSSTransitionGroup
      component="div"
      transitionName="fade"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500} >
      {React.cloneElement(children, {
        key: location.pathname
      })}
    </ReactCSSTransitionGroup>
  )
}

class Mainframe extends React.Component{

  constructor(props){

    super(props);

    this.state= {
      innerChapter : 0,
      isMobile : _assets.isMobile,
      mediaController : checkMediaController(),
      isIOS : _assets.isIOS,
      isLoading : true,
      loadStatus:0,
      firstSession : false,
      secondSession : false,
      orientation : 0, // portrait
      orientationCount : 0,
    }
    this.fps = 30;
    this.fpsInterval =  1000 / this.fps;
    this.then = 0;
    this.startTime = this.then;
    this.now=0;
    this.elapsed = 0;
    this.updateFunction = ()=>this.loop();//requestAnimationFrame();

  }

  cancelAnimationFrame(loop){
    cancelAnimationFrame(loop);
  }

  loop(){
    
    this.update = requestAnimationFrame(()=>this.loop());
    this.now = Date.now();
    this.elapsed = this.now - this.then;

    if (this.elapsed > this.fpsInterval) {

      this.then = this.now - (this.elapsed % this.fpsInterval);

      this.setState({
        loadStatus : _assets.getLoadStatus(),
      });

      if(this.state.loadStatus == 100 && !this.state.firstSession){
        this.setState({
           firstSession : true,
         });
        
      }
      
      if(_assets.second){
         this.setState({
           secondSession : true,
         });
         this.cancelAnimationFrame(this.update);
      }

    }//end of fps manipulation
  }

	render(){
		return (
			<Router basename={_assets.root} history={browserHistory}>
		    <Route path={_assets.root} component={App} >{/*blossom*/}
          
          <IndexRedirect to={"/blossomentary/intro"} />
           
          {/* Fallback if blob is not supported */}
          <Route key="fallback" path="fallback" component={
            props=> <FallbackPage />} />
          
          {/* Fallback if blob is not supported */}
          <Route key="inline_fallback" path="inline_fallback" component={
            props=> <IOSFallback />} />

          {/* Fallback if blob is not supported */}
          <Route key="instagram_fallback" path="instagram_fallback" component={
            props=> <Instagramfallback />} />

          {/* Twitter fallback is only an overlay */}

          {/* Intro */}
          <Route path='/' component={
            props=> <Intro 
              loadStatus={this.state.loadStatus}
              firstSession={this.state.firstSession}
              secondSession={this.state.secondSession}
              loadStatus={this.state.loadStatus} />} /> 

          <Route key="intro" path="intro" component={
            props=> <Intro 
              loadStatus={this.state.loadStatus}
              firstSession={this.state.firstSession}
              secondSession={this.state.secondSession}
              isIOS = {this.state.isIOS}  />} />

          {/* Outro*/}
          <Route key="outro" path="outro" component={
            props=> <Outro
              loadStatus={props.loadStatus}
              firstSession={props.firstSession}
              secondSession={props.secondSession}/>} />

          {/* Chapter 1 */}
          <Route key="chapter1" path="chapter1" chapter="1" component={props => <Chapter_One 
              loadStatus={this.state.loadStatus}
              firstSession={this.state.firstSession}
              secondSession={this.state.secondSession}
              loadStatus={this.state.loadStatus} 
              updateFunction={this.updateFunction}
              chapter={1} />} />
          {/* Chapter 2 */}
          <Route key="chapter2" path="chapter2" chapter="2" component={props => <Chapter_Two chapter={2}/> }/>
		      <Route key="chapter3" path="chapter3" chapter="3" component={props => <Chapter_Three chapter={3}/> }/>
          <Route path="*" component={NoMatch}/>
		    </Route>
		  </Router>
			)
	}

}

export default Mainframe;





// WEBPACK FOOTER //
// ./src/scripts/mainframe.js